import * as React from 'react';
import axios, { CancelTokenSource, CancelTokenStatic } from 'axios';
import clsx from 'clsx';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutState, CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { ElementDimensions } from '../../styles/ElementDimensions';
import ErrorDialog, { ErrorDialogProps } from '../common/ErrorDialog';
import { String_Check_CheckPaid, String_PayCheck_ErrorCreditCard, String_PayCheck_ErrorPaymentFailed, String_PayCheck_PaymentExceedsAmountDue, String_System_ConnectionError, String_System_GeneralError } from '../../utilities/StringHelper';
import { CheckState, CheckStateContext } from '../../providers/CheckStateContextProvider';
import { NavigateCheckOutStart } from '../common/NavigateCheckOutStart';
import GooglePayButton from '@google-pay/button-react';
import "../../styles/applePay.css";
import $ from 'jquery';
import { Skin } from '../../models/common/Skin';
import themePrimary from '../../styles/themePrimary';
import ThreeDS, { ThreeDSProps } from './ThreeDS';
import { useHistory } from 'react-router';
import { ErrorCode } from '../../models/common/ErrorCode';
import { ApplePaySessionRequest } from '../../models/payment/ApplePaySessionRequest';
import { ApplePaySessionResponse } from '../../models/payment/ApplePaySessionResponse';
import { PaymentDetail } from '../../models/payment/PaymentDetail';
import { MakePaymentRequest } from '../../models/payment/MakePaymentRequest';
import { PaymentDigitalWalletType } from '../../models/payment/PaymentDigitalWalletType';
import { MakePaymentResponse } from '../../models/payment/MakePaymentResponse';
import { SplitType } from '../../models/common/SplitType';
import { CreatePaymentRequest } from '../../models/payment/CreatePaymentRequest';
import { CreatePaymentResponse } from '../../models/payment/CreatePaymentResponse';
import { ApplePayToken } from '../../models/payment/ApplePayToken';
import { PaymentMethodsAccepted } from '../../models/payment/PaymentMethodsAccepted';

const useStyles = makeStyles({
    creditButton: {
        backgroundColor: '#000000 !important',
        color: themePrimary.palette.primary.contrastText,    
        boxShadow: 'none',
        fontSize: '1.5em',
        width: '300px',
        height: '46px',
        lineHeight: '46px',
        borderRadius: '5px',
        marginTop: '20px',
        marginLeft: 'auto',
        marginRight: 'auto',
        fontFamily: 'LeagueSpartan-Regular !important',
        fontWeight: 'bold',
    },
    googlePayButton: {
        width: '300px',
        height: '46px',
        marginTop: '20px !important',
        marginBottom: '0px !important',
    },
    iframe: {
        width: '100vw',
        height: '100%',
        borderWidth: '0',
    },
    iframeLandscape: {
        width: 'calc(100vw * .7)',
        height: '100%',
        borderWidth: '0',
        display: 'none',
    },
    root: {
        textAlign: 'center',
        height: 'calc(100vh - ' + (ElementDimensions.appBarHeight + ElementDimensions.stepperHeight + ElementDimensions.footerBarHeightPaymentScreen) + 'px)',
    },
    rootLandscape: {
        textAlign: 'center',
        height: '150%',
    },
});

export type GlobalPayGooglePaySuccessHandler = (paymentRequest: any) => any;
export type GlobalPayThreeDsOpenHandler = () => any;
export type GlobalPayThreeDsDoneHandler = () => any;
export type GlobalPayThreeDsErrorHandler = () => any;

export interface GlobalPayPaymentProps {
    total: number,
    paymentMethodAllowed: PaymentMethodsAccepted | undefined,
    threeDsDoneButtonClicked: boolean,
    threeDsOpenHandler: GlobalPayThreeDsOpenHandler,
    threeDsDoneHandler: GlobalPayThreeDsDoneHandler,
    threeDsErrorHandler: GlobalPayThreeDsErrorHandler,
    googlePaySuccessHandler: GlobalPayGooglePaySuccessHandler,
}

export default function GlobalPayPayment(props: GlobalPayPaymentProps) {
    const { total, paymentMethodAllowed, threeDsDoneButtonClicked, googlePaySuccessHandler, threeDsOpenHandler, threeDsDoneHandler, threeDsErrorHandler } = props;
    const isPortrait = true;
    let history = useHistory();
    const applePayEl = React.useRef(null);
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const checkState = React.useContext(CheckStateContext);
    const [threeDsDone, setThreeDsDone] = React.useState<boolean>(false);
    const [trigger3dsDone, setTrigger3dsDone] = React.useState<boolean>(false);
    const [isLoaded, setIsLoaded] = React.useState<boolean>(false);
    const [applePayLoaded, setApplePayLoaded] = React.useState<boolean>(false);
    const [threeDsOpen, setThreeDsOpen] = React.useState<boolean>(false);
    const [errorDialogOpen, setErrorDialogOpen] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>('');
    const [errorDialogTryAgain, setErrorDialogTryAgain] = React.useState<boolean>(true);
    const [showDigitalWallets, setShowDigitalWallets] = React.useState<boolean>(true);
    const [checkPaidError, setCheckPaidError] = React.useState<boolean>(false);
    const [paymentExceedsAmountDueError, setPaymentExceedsAmountDueError] = React.useState<boolean>(false);
    const [paymentError, setPaymentError] = React.useState<boolean>(false);
    const [totalChangedError, setTotalChangedError] = React.useState<boolean>(false);
    const [createPaymentComplete, setCreatePaymentComplete] = React.useState<boolean>(false);
    const [hppToken, setHppToken] = React.useState<string>('');
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const applePayScriptLoaded = () => {
        //@ts-ignore
        if (window.ApplePaySession) {
            var merchantIdentifier = checkOutState.state.applePayMerchantId;

            //@ts-ignore
            var promise = ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
            promise.then(function (canMakePayments: boolean) {
                if (canMakePayments) {
                    const applePayDiv: HTMLDivElement = applePayEl.current!!
                    applePayDiv.innerHTML = "<apple-pay-button onclick='var data = {action: \"applePay\"}; window.postMessage(data);' id='applePayButton' buttonstyle='black' type='check-out' style='margin-top: 20px !important; margin-bottom: 0px !important; --apple-pay-button-width: 300px; --apple-pay-button-height: 40px; --apple-pay-button-border-radius: 5px;--apple-pay-button-padding: 5px 0px;'></apple-pay-button>"
                    setApplePayLoaded(true);
                }
        }); }
    }

    const applePayScriptError = () => {
        
    }

    const globalPayScriptLoaded = () => {
        setIsLoaded(true)

    }

    const globalPayScriptError = () => {
        
    }

    const messageHandler = (event: { data: any; }) => {
        try{
            if (event.data.action === "applePay") {
                onApplePayClickHandler();
            }
        }
        catch (exception) {

        }
    }

    React.useEffect(() => {
        if (!isLoaded && !createPaymentComplete) {

            const LoadApplePayExternalScript = () => {
                const externalScript = document.createElement("script");
                externalScript.onload = applePayScriptLoaded;
                externalScript.onerror = applePayScriptError;
                externalScript.id = "external";
                externalScript.async = true;
                externalScript.type = "text/javascript";
                document.body.appendChild(externalScript);
                externalScript.src = getApplePayScriptUrl()
            }

            LoadApplePayExternalScript()

            const LoadGlobalPayExternalScript = () => {
                const externalScript = document.createElement("script");
                externalScript.onload = globalPayScriptLoaded;
                externalScript.onerror = globalPayScriptError;
                externalScript.id = "external";
                externalScript.async = true;
                externalScript.type = "text/javascript";
                document.body.appendChild(externalScript);
                externalScript.src = getGlobalPayScriptUrl()
            }

            LoadGlobalPayExternalScript()
        }       
        
        if (threeDsDoneButtonClicked) {
            setTrigger3dsDone(true)
        }
        else {
            setTrigger3dsDone(false)
        }

        window.removeEventListener("message", messageHandler);
        window.addEventListener("message", messageHandler);

    }, [createPaymentComplete, threeDsDoneButtonClicked]);

    const createGlobalPayPayment = (cancelTokenSource: CancelTokenSource, address: string, city: string, postalCode: string, 
        emailAddress: string, phoneNumber: string, country: string, nationalPhoneNumber: string, countryCode: string) => {
        const request: CreatePaymentRequest = {
            user_id: userState.state.userId!!,
            table_id: checkOutState.state.tableId,
            check_please_payment_id: checkState.state.paymentId!!,
            total: total,
            address: address,
            city: city,
            postal_code: postalCode,
            email_address: emailAddress,
            phone_number: phoneNumber,
            country: country,
            national_phone_number: nationalPhoneNumber,
            country_code: countryCode
        }

        let url: string | undefined = process.env.REACT_APP_CHECKOUT_API_URL + "/location/" + checkOutState.state.restaurantId + "/checks/" + checkState.state.checkSummary!!.id + "/payment/create"

        const headers = {
            'X-API-Key': checkOutState.state.restaurantApiKey,
            'location_id': checkOutState.state.restaurantId
        }

        axios.post(url, request, { headers, cancelToken: cancelTokenSource.token })
        .then(function(response) {
            let r = response.data as CreatePaymentResponse;

            if (r.success === true) {
                setHppToken(r.payment_token!!)
                setCreatePaymentComplete(true)

                //@ts-ignore
                RealexHpp.setHppUrl(process.env.REACT_APP_GLOBALPAY_HPP_URL);
                //@ts-ignore
                RealexHpp.embedded.init("", "globalpayframe", process.env.REACT_APP_BASE_URL + "/payment/globalpaycomplete", JSON.parse(r.payment_token!!));
            }
            else {
                 if (r.error_code === ErrorCode.CheckAlreadyPaid) {
                    setCheckPaidError(true);
                    setErrorDialogTryAgain(false);
                    setErrorMessage(String_Check_CheckPaid.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogOpen(true);
                }            
                else if (r.error_code === ErrorCode.PaymentFailed)
                {
                    setErrorMessage(String_PayCheck_ErrorPaymentFailed.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogTryAgain(false);
                    setErrorDialogOpen(true);
                    setPaymentError(true);
                }
                else if (r.error_code === ErrorCode.PaymentAmountExceedsAmountDue)
                {
                    setPaymentExceedsAmountDueError(true);
                    setErrorMessage(String_PayCheck_PaymentExceedsAmountDue.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogTryAgain(false);
                    setErrorDialogOpen(true);
                }
            }
        })
        .catch(function(error) {
            if (error.response) {
                setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(true);
                setErrorDialogOpen(true);
            }
            else {
                setErrorMessage(String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogTryAgain(true);
                setErrorDialogOpen(true);
            }
        });
    };

    const getApplePayScriptUrl = (): string => {
        return "https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js"
    }

    const getGlobalPayScriptUrl = (): string => {
        return process.env.REACT_APP_BASE_URL + "/globalpay/rxp-js.js"
    }

    const onCreditButtonClick = () => {
        setThreeDsOpen(true)
        threeDsOpenHandler();
        /*setThreeDsDone(true)
        setThreeDsOpen(false)

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();

        createGlobalPayPayment(source, "", "", "", "", "", "", "", "");*/
    }

    const handleThreeDsDone = (address: string, city: string, postalCode: string, emailAddress: string, 
        phoneNumber: string, country: string, nationalPhoneNumber: string, countryCode: string) => {
        setThreeDsDone(true)
        setThreeDsOpen(false)
        threeDsDoneHandler()

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();

        createGlobalPayPayment(source, address, city, postalCode, emailAddress, phoneNumber, country, nationalPhoneNumber, countryCode);
    }

    const handleThreeDsError = () => {
        threeDsErrorHandler();
    };

    const threeDsDialogProps: ThreeDSProps = {
        open: threeDsOpen,
        doneButtonClicked: trigger3dsDone,
        onDoneHandler: handleThreeDsDone,
        onErrorHandler: handleThreeDsError,
    }

    const handleErrorDialogClose = (event: React.MouseEvent<HTMLElement>) => {
        setErrorDialogOpen(false);
        
        if (paymentExceedsAmountDueError) {
            history.push('/checkout/check');
        }
        else if (totalChangedError) {
            history.goBack();
        }
        else if (checkPaidError) {
            NavigateCheckOutStart();
        }
        else if (paymentError) {
            window.location.reload();
        }
    }

    const errorDialogProps: ErrorDialogProps = {
        open: errorDialogOpen,
        message: errorMessage,
        tryAgain: errorDialogTryAgain,
        onCloseHandler: handleErrorDialogClose,
    }

    const onApplePayClickHandler = async () => {
        var request = {
            countryCode: checkOutState.state.restaurantCountry,
            currencyCode: checkOutState.state.restaurantCurrency,
            supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
            merchantCapabilities: ["supportsCredit", "supportsDebit","supports3DS"],
            total: { label: checkOutState.state.restaurantName!!, amount: (total / 100).toString() },
          }
          //@ts-ignore
          var session = new ApplePaySession(1, request);

          session.onvalidatemerchant = function(event: any) {
            const cancelToken = axios.CancelToken;
            const source = cancelToken.source();

            const applePaySessionRequest: ApplePaySessionRequest = {
                user_id: userState.state.userId!!,
                validation_url: event.validationUrl,
            }

            let url: string | undefined = process.env.REACT_APP_CHECKOUT_API_URL + "/location/" + checkOutState.state.restaurantId + "/checks/" + checkState.state.checkSummary!!.id + "/payment/applepay"

            const headers = {
                'X-API-Key': checkOutState.state.restaurantApiKey,
                'location_id': checkOutState.state.restaurantId
            }

            axios.post(url, applePaySessionRequest, { headers, cancelToken: source.token })
            .then(function(response) {
                let r = response.data as ApplePaySessionResponse;

                if (r.success === true) {
                    session.completeMerchantValidation(JSON.parse(r.session));
                }
                else {
                    setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogTryAgain(true);
                    setErrorDialogOpen(true);
                }
            })
            .catch(function(error) {
                if (error.response) {
                    setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogTryAgain(true);
                    setErrorDialogOpen(true);
                }
                else {
                    setErrorMessage(String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogTryAgain(true);
                    setErrorDialogOpen(true);
                }
            });
        }

        session.onpaymentauthorized = function(event: any) {
            const cancelToken = axios.CancelToken;
            const source = cancelToken.source();

            console.log(JSON.stringify(event.payment.token.paymentData));

            const paymentDetail: PaymentDetail = {
                tip: checkState.state.tip,
                tax: checkState.state.checkTotal!!.tax,
                sub_total: checkState.state.checkTotal!!.sub_total,
                amount_to_pay: checkState.state.checkTotal!!.amount_due,
                total: checkState.state.checkTotal!!.total,
                zip_code: '',
                token: JSON.stringify(event.payment.token.paymentData),
                serial_number: '',
                extended_card_data: '',
                card_number_last_four: '',
                guest_last_name: '',
                room_number: '',
                session_id: ''
            }

            const applePayToken: ApplePayToken = {
                signature: event.payment.token.paymentData.signature,
                data: event.payment.token.paymentData.data,
                publicKeyHash: event.payment.token.paymentData.header.publicKeyHash,
                transactionId: event.payment.token.paymentData.header.transactionId,
                version: event.payment.token.paymentData.version,
                transactionIdentifier: event.payment.token.transactionIdentifier,
                displayName: event.payment.token.paymentMethod.displayName,
                type: event.payment.token.paymentMethod.type,
                network: event.payment.token.paymentMethod.network,
                ephemeralPublicKey: event.payment.token.paymentData.header.ephemeralPublicKey,
            }
    
            const request: MakePaymentRequest = {
                user_id: userState.state.userId!!,
                table_id: checkOutState.state.tableId,
                check_please_payment_id: checkState.state.paymentId!!,
                payment_method: null,
                payment_digital_wallet_type: PaymentDigitalWalletType.ApplePay,
                payment_detail: paymentDetail,
                globalpay_hpp_response: null,
                apple_pay_token: applePayToken,
                google_pay_token: null
            };
            
            let url: string | undefined = process.env.REACT_APP_CHECKOUT_API_URL + "/location/" + checkOutState.state.restaurantId + "/checks/" + checkState.state.checkSummary!!.id + "/payment/process"
    
            const headers = {
                'X-API-Key': checkOutState.state.restaurantApiKey,
                'location_id': checkOutState.state.restaurantId
            }
            
            axios.post(url, request, { headers, cancelToken: source.token })
            .then(function(response) {
                let r = response.data as MakePaymentResponse;
                
                if (r.success === true) {
                    session.completePayment((window as any).ApplePaySession.STATUS_SUCCESS);

                    const state: CheckState = checkState.state;
                    state.checkSummary = null;
                    state.checkDetail = null;
                    state.checkTotal = null;
                    state.paymentId = null;
                    state.splitType = SplitType.None;
                    state.splitPercentage = 0;
                    state.splitAmount = 0;
                    state.splitEvenlyCount = 0;
                    state.checkTotalWithTip = '';
                    state.tip = 0;
                    state.tipString = '';
                    checkState.setState(state);

                    if (r.restaurant_id != null) {
                        const coState: CheckOutState = checkOutState.state;
                        coState.restaurantId = r.restaurant_id;
                        checkOutState.setState(coState);
                    }
        
                    history.push({
                        pathname: '/postcheckout/review',
                        state: { 
                            paymentId: r.check_please_payment_id,
                        }
                    });
                }
                else {
                    session.completePayment((window as any).ApplePaySession.STATUS_FAILURE);

                    if (r.error_code === ErrorCode.CheckAlreadyPaid) {
                        setCheckPaidError(true);
                        setErrorDialogTryAgain(false);
                        setErrorMessage(String_Check_CheckPaid.find(s => s.key === userState.state.locale)!!.value);
                        setErrorDialogOpen(true);
                    }            
                    else if (r.error_code === ErrorCode.PaymentFailed)
                    {
                        setErrorMessage(String_PayCheck_ErrorPaymentFailed.find(s => s.key === userState.state.locale)!!.value);
                        setErrorDialogTryAgain(false);
                        setErrorDialogOpen(true);
                    }
                    else if (r.error_code === ErrorCode.PaymentAmountExceedsAmountDue)
                    {
                        setPaymentExceedsAmountDueError(true);
                        setErrorMessage(String_PayCheck_PaymentExceedsAmountDue.find(s => s.key === userState.state.locale)!!.value);
                        setErrorDialogTryAgain(false);
                        setErrorDialogOpen(true);
                    }
                }              
            })
            .catch(function(error) {
                session.completePayment((window as any).ApplePaySession.STATUS_FAILURE);
                
                if (error.response) {
                    setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogTryAgain(false);
                    setErrorDialogOpen(true);
                }
                else {
                    setErrorMessage(String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogTryAgain(false);
                    setErrorDialogOpen(true);
                }
            });
        }

        session.oncancel = function (event: any) {
            
        }

        session.begin();
    }
    
    return (
        <div className={clsx({
            [classes.root]: isPortrait,
            [classes.rootLandscape]: !isPortrait,
        })}>

            {createPaymentComplete && 
                <iframe 
                    id="globalpayframe"
                    className={clsx({
                        [classes.iframe]: isPortrait,
                        [classes.iframeLandscape]: !isPortrait,
                })}></iframe>
            }

            {threeDsOpen &&
                <ThreeDS
                    open={threeDsDialogProps.open}
                    doneButtonClicked={threeDsDialogProps.doneButtonClicked}
                    onDoneHandler={threeDsDialogProps.onDoneHandler}
                    onErrorHandler={threeDsDialogProps.onErrorHandler} />
            }

            {!createPaymentComplete && !threeDsOpen && !threeDsDone &&
                <div className={classes.creditButton} id="btnCredit" onClick={onCreditButtonClick}>Credit Card</div>
            }

            {showDigitalWallets && !createPaymentComplete && !threeDsOpen && !threeDsDone &&
                <div id="digitalWalletButtons">
                   
                    <GooglePayButton
                        className={classes.googlePayButton}
                        environment={process.env.REACT_APP_GOOGLEPAY_ENVIRONMENT!! as google.payments.api.Environment}
                        buttonColor="default"
                        buttonType="checkout"
                        buttonSizeMode="fill"
                        onLoadPaymentData={paymentRequest => {
                            googlePaySuccessHandler(paymentRequest)
                        }}
                        onError={error => {
                            console.log(error);
                            setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                            setErrorDialogTryAgain(true);
                            setErrorDialogOpen(true);
                        }}
                        paymentRequest={{
                            apiVersion: 2,
                            apiVersionMinor: 0,
                            allowedPaymentMethods: [
                            {
                                type: 'CARD',
                                parameters: {
                                allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                                allowedCardNetworks: ['MASTERCARD', 'VISA', 'AMEX', 'DISCOVER'],
                                },
                                tokenizationSpecification: {
                                type: 'PAYMENT_GATEWAY',
                                parameters: {
                                    gateway: 'globalpayments',
                                    gatewayMerchantId: checkOutState.state.restaurantGooglePayMerchantId!!,//'oebkitchenbar',
                                },
                                },
                            },
                            ],
                            merchantInfo: {
                                //merchantId: "12345678901234567890",
                                //merchantName: "Demo Merchant",
                                merchantId: "BCR2DN4TVHU6N2DT",
                                merchantName: "CHECKPLEASE, LLC",
                            },
                            transactionInfo: {
                            totalPriceStatus: 'FINAL',
                            totalPriceLabel: 'Total',
                            totalPrice: (total / 100).toString(),
                            currencyCode: checkOutState.state.restaurantCurrency!!,
                            countryCode: checkOutState.state.restaurantCountry!!,
                            },
                        }}
                    />

                    <div ref={applePayEl}>

                    </div>

                </div>
            }

            <ErrorDialog 
                open={errorDialogProps.open}
                message={errorDialogProps.message}
                tryAgain={errorDialogProps.tryAgain}
                onCloseHandler={errorDialogProps.onCloseHandler} />                 
            
        </div>        
    );
}